module.exports = __webpack_public_path__ + "static/img/caiwubiaoxian2.079f22fc.png";